import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountStatusesEnum } from 'dash-common';
import {
  Box,
  DropDown,
  Icon,
  ModalContext,
  ViewerContext,
} from 'dash-ui';

import {
  OrganizationUser,
  GetOrganizationUsersByOrganizationRoleDocument,
  useSendRegistrationLinkToDeveloperMutation,
} from 'gql/generated.graphql';
import { OrganizationUsersModalsEnum } from 'pages/OrganizationPage/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/constants/constants';

const OrganizationUserTableRowActions = ({
  user,
}: {
  user: OrganizationUser;
}) => {
  const { t } = useTranslation(['common', 'tables']);
  const { toggleModal, setPayload } = useContext(ModalContext);
  const { account } = useContext(ViewerContext);
  const [sendRegistrationLinkToUser, { loading }] =
    useSendRegistrationLinkToDeveloperMutation();

  const sendItemOnClick = () => {
    sendRegistrationLinkToUser({
      variables: { accountId: user.account._id },
      refetchQueries: [GetOrganizationUsersByOrganizationRoleDocument],
    });
  };

  return (
    <Box w={16}>
      <DropDown
        data-testid="actions-dropdown"
        Anchor={() => <Icon name="dots" />}
        items={[
          {
            key: 'send',
            icon: 'send',
            children: t(
              `tables:organizationUsers.${
                user.account.status === AccountStatusesEnum.ADDED
                  ? 'sendInvitation'
                  : 'resendInvitation'
              }`
            ),
            iconProps: { size: 14 },
            disabled:
              user.account.status === AccountStatusesEnum.ARCHIVED ||
              user.account.status === AccountStatusesEnum.ACTIVE,
            contentCentered: false,
            w: 170,
            onClick: sendItemOnClick,
            isLoading: loading,
          },
          {
            key: 'archive',
            icon: 'archive',
            children: t('common:labels.archive'),
            w: 170,
            disabled:
              user.account.status !== AccountStatusesEnum.ACTIVE ||
              user.account._id === account?._id,
            contentCentered: false,
            onClick: () => {
              setPayload({
                status: AccountStatusesEnum.ARCHIVED,
                organizationUserId: user._id,
              });
              toggleModal(
                true,
                OrganizationUsersModalsEnum.SET_ORGANIZATION_USER_STATUS
              );
            },
          },
          {
            key: 'unarchive',
            icon: 'unarchive',
            children: t('common:labels.unarchive'),
            disabled: user.account.status !== AccountStatusesEnum.ARCHIVED,
            contentCentered: false,
            w: 170,
            onClick: () => {
              setPayload({
                status: AccountStatusesEnum.ACTIVE,
                organizationUserId: user._id,
              });
              toggleModal(
                true,
                OrganizationUsersModalsEnum.SET_ORGANIZATION_USER_STATUS
              );
            },
          },
        ]}
      />
    </Box>
  );
};

export default OrganizationUserTableRowActions;
